import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  FrontpageService,
  Swimlane,
} from '../../../generated-api';
import { FrontpageConfigStoreService } from '../stores/frontpage-config-store.service';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import {
  STREAM_BOXES,
  TV_BOXES,
  TOPLIST_BOXES
} from '../../../core/helpers/constants/tv-overview';
import { ChannelsScrollerModel } from '../helpers/channels-scroller.model';
import { shuffle } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class FrontpageConfigService {
  constructor(
    private frontpageConfigService: FrontpageService,
    private store: FrontpageConfigStoreService,
    private translateService: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  getFrontpageConfig(previewId): void {
    if (previewId) {
      // preview
      this.store.loading = true;
      this.frontpageConfigService
        .getFrontpage2Preview(previewId, 'body')
        .pipe(
          catchError((err) => {
            this.store.loading = false;
            this.store.searchError =
              this.translateService.instant('error.internal');
            this.store.fpConfig = null;
            return EMPTY;
          })
        )
        .subscribe((value) => {
          if (value) {
            this.store.loading = false;
            this.store.searchError = null;
            this.store.fpConfig = value;
          }
        });
    } else {
      this.store.loading = true;
      this.frontpageConfigService
        .getFrontpage2('body')
        .pipe(
          catchError((err) => {
            this.store.loading = false;
            this.store.searchError =
              this.translateService.instant('error.internal');
            this.store.fpConfig = null;
            return EMPTY;
          })
        )
        .subscribe((value) => {
          if (value) {
            this.store.loading = false;
            this.store.searchError = null;
            this.store.fpConfig = this.filterEmptySwimlanes(value);

            // Stale-while-revalidate: If we are in the browser, the first response came from the TransferCache.
            // We immediately make a second background request to get the fresh data.
            if (isPlatformBrowser(this.platformId)) {
                setTimeout(() => {
                    this.frontpageConfigService.getFrontpage2('body').subscribe(liveValue => {
                        if (liveValue) {
                            this.store.fpConfig = this.filterEmptySwimlanes(liveValue);
                        }
                    });
                }, 0);
            }
          }
        });
    }
  }

  private filterEmptySwimlanes(config: any): any {
    if (!config || !config.rows) return config;
    config.rows = config.rows.filter(
      (row) =>
        (row.rowType == 'swimlane' &&
          row !== null &&
          row !== undefined &&
          row.data != null &&
          row.data != undefined &&
          ((row.data as Swimlane)?.items?.length ?? 0) > 0) ||
        row.rowType != 'swimlane'
    );
    return config;
  }

  getTvBoxList(): ChannelsScrollerModel[] {
    return TV_BOXES;
  }

  shuffleChannels(channels: ChannelsScrollerModel[]): ChannelsScrollerModel[] {
    let currentIndex = channels.length;

    while (currentIndex != 0) {
      let randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [channels[currentIndex], channels[randomIndex]] = [channels[randomIndex], channels[currentIndex]];
    }
  
    return channels;
  }

  getToplistBoxList(): ChannelsScrollerModel[] {
    return this.shuffleChannels(TOPLIST_BOXES);
  }

  getStreamBoxList(): ChannelsScrollerModel[] {
    return STREAM_BOXES;
  }
}
